<template>
  <div>
    <div class="text-xl font-black py-2">10. Agree actions and objectives</div>

    <div class="pt-4 px-2">
      <div>Please discuss with your Fine & Country representative and write down any action points or objectives you both agree on:</div>
      <div v-if="actions && actions.length">
        <div v-for="(item, index) in this.actions" :key="index" class="pt-4">
          <textarea rows="2" :value="item" class="w-full py-2 px-3 border-2 rounded bg-white outline-none focus:border-primary-500 border-gray-300 hover:border-gray-400" disabled></textarea>
        </div>
      </div>
      <div v-if="additionalActions && additionalActions.length">
        <div v-for="(item2, index2) in this.additionalActions" :key="index2" class="pt-4">
          <textarea-input v-model="additionalActions[index2].value" :rows="2" :id="'action'+item2" />
        </div>
      </div>
      <div v-if="(!actions || !actions.length) && (!additionalActions || !additionalActions.length)" class="py-4" >
        No action added yet. Please click Add button to add new action points
      </div>
    </div>

    <div class="pt-4">
      <div class="text-green text-lg cursor-pointer" @click="addActions">+ Add additional action points</div>
    </div>
  </div>
</template>

<script>
import ErrorBag from '@/ErrorBag'

export default {
  props: ['value', 'review', 'page', 'sectionStart', 'showMandatory'],
  data () {
    return {
      form: this.value,
      newNum: 0,
      actions: [],
      additionalActions: this.review.additionalActions,
      errorBag: new ErrorBag()
    }
  },
  mounted () {
    // add action questions to the actions
    console.log(this.form)
    for (var pageIndex in this.form.questions) {
      for (var sectionIndex in this.form.questions[pageIndex]) {
        for (var questionIndex in this.form.questions[pageIndex][sectionIndex]) {
          var question = this.form.questions[pageIndex][sectionIndex][questionIndex]
          if (question.agreed_flag && question.result === true) {
            this.actions.push(question.title)
          }
        }
      }
    }
  },
  watch: {
  },
  methods: {
    addActions () {
      this.additionalActions.push({ 'value': '' })
    }
  }
}
</script>
